import React from "react";
import { Box, Card, CardMedia, Typography } from "@mui/material";

const Card17Image2 = ({ card, handleCategoryClick }) => (
  <Box sx={{ marginBottom: 3 }} key={card.cardMetaData?.id}>
    {card.cardMetaData?.title && (
      <Typography
        variant="h6"
        sx={{
          marginBottom: 1,
          fontWeight: "bold",
          fontSize: "16px",
          color: "#771615",
        }}
      >
        {card.cardMetaData.title}
      </Typography>
    )}

    <Box
      sx={{
        display: "flex",
        gap: 2,
        overflowX: "auto",
        padding: "8px 0",
      }}
    >
      {card.cardData.map((item, idx) => (

        <Card
          key={idx}
          onClick={() =>
            handleCategoryClick(item.data.onTap?.FAI?.typeId, item.data.onTap?.FAI?.type,item.data.displayName)
          }
          sx={{
            minWidth: 110,
            height: 110,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 2,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
          }}
        >
          <CardMedia
            component="img"
            image={item.data.imageUrl}
            alt={item.data.displayName}
            sx={{
              width: 110,
              height: 110,
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        </Card>
      ))}
    </Box>
  </Box>
);

export default Card17Image2;